import React from "react";
import styled from "@emotion/styled";
import BackHeader from "@components/header/BackHeader";
import TabWithPanel from "@components/tab/TabWithPanel";
import { BuyInquiryTab, SellInquiryTab } from "@pages/myPage/_component";
import { useTranslation } from "react-i18next";

const InquiryContainer = styled.div({
  display: "flex",
  flexDirection: "column",
});

const SellBuyInquiry = () => {
  const { t } = useTranslation();

  const tabList = [
    {
      label: t("구매 문의"),
      key: "1",
      children: <BuyInquiryTab />,
    },
    {
      label: t("판매 문의"),
      key: "2",
      children: <SellInquiryTab />,
    },
  ];

  return (
    <InquiryContainer>
      <BackHeader title="문의하기" />

      <TabWithPanel item={tabList} underline />
    </InquiryContainer>
  );
};

export default SellBuyInquiry;
